import React from 'react';

const Footer: React.FC = () => {
  return (
    <div
      style={{
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.45)',
        fontSize: 14,
        lineHeight: '22px',
      }}
    >
      <div
        style={{
          marginBottom: 0,
        }}
      >
        AI智慧监控平台（管理端）
      </div>
      <div
        style={{
          marginTop: 0,
        }}
      >
        © Powered by sxt
      </div>
    </div>
  );
};

export default Footer;
